import axios from "axios";
import { refreshToken } from "../redux/authSlice";

// ****  NOTE  ****
// // Order Matters: Interceptors are executed in the order they're added.

const api = axios.create({
  baseURL: process.env.REACT_APP_LOCAL_HOST,
  withCredentials: true,
});

export const configureApiInterceptors = (store) => {
  // Request Interceptor: Attach token to headers
  api.interceptors.request.use(
    (config) => {
      const token = store.getState().auth.accessToken;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response Interceptor: Handle token expiration
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Skip retry if the request is to refresh endpoint
      const baseURL = process.env.REACT_APP_LOCAL_HOST;
      const relativeUrl = originalRequest.url.replace(baseURL, "");

      if (relativeUrl === "auth/refresh") {
        return Promise.reject(error);
      }

      // Handle 401 errors and retry once
      if (error.response?.status === 401 && !originalRequest._retry) {
        console.warn("401 error — attempting token refresh...");
        originalRequest._retry = true;

        try {
          const newToken = await store.dispatch(refreshToken()).unwrap();
          // console.log("New token: ", newToken);

          // Retry the original request with the new token
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;

          console.info("YAY: The access token was refreshed successfully");
          return await api(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed:", refreshError);

          // Optional: Dispatch logout or redirect to login
          // store.dispatch(logoutUser());

          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );

  // Response Interceptor:  Handle 429 Rate Limiter Error
  // api.interceptors.response.use(
  //   (response) => response,
  //   async (error) => {
  //     if (error.response?.status === 429) {
  //       const retryAfter = error.response.headers["retry-after"] || 5; // Default to 5s if not provided

  //       console.warn(`Rate limited. Retrying after ${retryAfter} seconds...`);

  //       await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000)); // Wait

  //       return api.request(error.config); // Retry request
  //     }

  //     return Promise.reject(error); // Reject other errors
  //   }
  // );
};

export default api;
